import { useAppSelector } from "../../../../Redux/hooks";
import ConsentPropertiesModal from "./ConsentPropertiesModal";

const ConsentPropertiesModalWrapper = () => {
  const showPropModal = useAppSelector((state) => state.consent.showPropModal);
  return showPropModal ? <ConsentPropertiesModal /> : null;
};

export default ConsentPropertiesModalWrapper;
